import React from 'react';
import {FormControl, FormHelperText} from "@mui/material";
import CellInput, {CellInputProps} from "./CellInput"

function CellInputWithHelperText({column, value, onChange, sx}: CellInputProps) {
    return (
        <FormControl>
            <CellInput column={column} value={value} onChange={onChange} sx={sx}/>
            {column.helperText && <FormHelperText>{column.helperText}</FormHelperText>}
        </FormControl>
    )
}

export default CellInputWithHelperText;